$(() => {
  const summonNow = dayjs();
  const summonNowFormatted = summonNow.format('YYYY-MM-DD');
  const lastYear = summonNow.clone().subtract(1, 'years').format('YYYY-MM-DD');
  const lastThreeYears = summonNow.clone().subtract(3, 'years').format('YYYY-MM-DD');
  const lastFiveYears = summonNow.clone().subtract(5, 'years').format('YYYY-MM-DD');
  const $summonAnyYear = $('#summon-any');
  const $summon1Year = $('#summon-1year');
  const $summon3Year = $('#summon-3year');
  const $summon5Year = $('#summon-5year');
  const $summonPubInputs = $("#summon-publication-inputs");

  $summon1Year.val(`PublicationDate,${lastYear}:${summonNowFormatted}`);
  $summon3Year.val(`PublicationDate,${lastThreeYears}:${summonNowFormatted}`);
  $summon5Year.val(`PublicationDate,${lastFiveYears}:${summonNowFormatted}`);

  $summonPubInputs.find("input").on('click', function(){
    $(this).prop('checked',true)
           .parent()
           .siblings()
           .find("input")
           .prop('checked',false);
  });


});
